import { WaitlistConfigurationModel } from "../../../types/generated/models";
import { useGetQuery } from "../../../hooks/useClientPortalQuery";
import { UseQueryResult } from "@tanstack/react-query";

export interface IUseWaitlistRequestConfigurationHook {
    data?: WaitlistConfigurationModel | null;
    isLoading: boolean;
    refetchWaitlistRequestConfiguration: () => Promise<UseQueryResult<WaitlistConfigurationModel, Error>>;
}

export function useWaitlistRequestConfiguration(guidKey: string): IUseWaitlistRequestConfigurationHook {
    const { data, isLoading, refetch } = useGetQuery<WaitlistConfigurationModel>({
        url: `/api/v1.0/${guidKey}/Waitlist/GetWaitlistConfiguration`,
    });

    return {
        data,
        isLoading,
        refetchWaitlistRequestConfiguration: refetch,
    };
}
